import { render } from "./TutorialSpotlight.vue?vue&type=template&id=4a407acc&scoped=true"
import script from "./TutorialSpotlight.vue?vue&type=script&lang=js"
export * from "./TutorialSpotlight.vue?vue&type=script&lang=js"

import "./TutorialSpotlight.vue?vue&type=style&index=0&id=4a407acc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a407acc"]])

export default __exports__